import { ActivityContext } from './SignupJourneyContext'

export const DEFAULT_ACTIVITY_VALUES: ActivityContext = {
  venueTypeCode: '',
  socialUrls: [''],
  targetCustomer: undefined,
  phoneNumber: '',
}
